export enum ProjectsActionTypes {
  FETCH_PROJECTS_LIST_SUCCESS = "FETCH_PROJECTS_LIST_SUCCESS",
  FETCH_PROJECTS_LIST_ERROR = "FETCH_PROJECTS_LIST_ERROR",
  FETCH_PROJECTS_LIST = "FETCH_PROJECTS_LIST",
}

interface FetchProjectsList {
  type: ProjectsActionTypes.FETCH_PROJECTS_LIST
}

interface FetchProjectsListSuccess {
  type: ProjectsActionTypes.FETCH_PROJECTS_LIST_SUCCESS
  payload: IProjectForSelect[]
}

interface FetchProjectsListError {
  type: ProjectsActionTypes.FETCH_PROJECTS_LIST_ERROR
  payload: string
}

export type ProjectsAction = FetchProjectsList | FetchProjectsListSuccess | FetchProjectsListError

export interface ProjectsState {
  projects: IProjectForSelect[]
  loaded: boolean
  error: string | null
}

export interface IProjectForSelect {
  _id: string
  title: string
}
